import { inject, Injectable } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HISTORY_API_BASE_URL } from '../../api-base-url.token';
import { SealedBidHistoryResponseDto } from '../../schemas/bid-responses/sealed-bid-history-response.dto';

@Injectable({ providedIn: 'root' })
export class SealedBidHistoryAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(HISTORY_API_BASE_URL)}/sealedBidHistoryAdmin`;

    getAll(auctionId: number) {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<SealedBidHistoryResponseDto[]>()
            .withHttpParams(new HttpParams().set('auctionId', auctionId))
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<SealedBidHistoryResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }
}
